:host {
  width: 100%;
  --aha-card-divider--border-color: var(--theme-primary-border);
}

div {
  /**
   * We need to pad the `hr` inside a `div` so that drag-and-drop events will register
   * on the parent (events aren't captured in margins)
   */
  padding: 0.5em 0;
}

hr {
  border: none;
  border-bottom: 1px solid var(--aha-card-divider--border-color);
  margin: 0;
}
